export default __webpack_public_path__ + "static/media/7minfitness_1@3x.1bcbfd0f.jpg";